import { ApiClient, ApiResponse, ServiceBase } from './api'
import { HouseBillSchema, MasterBill } from './CustomsV2Service'

import { Business } from '@/pages/outbound/stores/scanStore'

// 仓库区域响应模型
export interface WarehouseAreaResponse {
  areaId: number
  areaName: string
  areaCode: string
}

// 仓库货位响应模型
export interface WarehousePositionResponse {
  positionId: number
  positionCode: string
  positionName?: string
}

// 托盘信息响应模型
export interface PalletInfoResponse {
  palletId: number
  palletCode: string
  palletStatus: string
  entryDate?: string // ISO datetime string
  boxCountForThisCargo: number
  position: WarehousePositionResponse
  area: WarehouseAreaResponse
}

// 带仓库信息的货物明细响应模型
export interface CargoMarkWithWarehouseResponse {
  cargoDetailId: number
  cargoNumber?: string
  packageType?: string
  packages?: number
  // sequence_number: number
  palletsInfo: PalletInfoResponse[]
}

// 带仓库详情的分提单响应模型
export interface HouseBillWithWarehouse {
  masterBill: {
    customerNumber: string
  }
  houseBillId: number
  houseBlNumber: string
  status: string
  statusDisplay: string
  scheduledOutboundDate?: string // YYYY-MM-DD format
  note: string
  cargoBoxCount: number
  volumeCbm: number
  weightKg: number
  // master_bill_id: number
  // sequence_number: number
  cargoMarks: CargoMarkWithWarehouseResponse[]
  deliveryOpt: string
  deliveryNote: string
}

export interface DeliverySchedule {
  scheduledOutboundDate: string
  deliveryOpt: string
  deliveryNote: string
}

export interface CargoMarkSchema {
  id: number
  cargoNumber: string
  sequenceNumber: number
  packages: number
}
export interface PalletMarkSchema {
  /** Mark ID */
  id: number
  /** 在该托盘中的数量 */
  quantity: number
  /** mark详情 */
  cargoMark: CargoMarkSchema | null
}
export interface WarehousePossitionSchema {
  id: number
  code: string
  name: string
}
export interface PalletPositionSchema {
  /** 托盘ID */
  id: number
  /** 托盘编码 */
  palletCode: string
  /** 托盘状态 */
  status: string
  statusDisplay: string
  /** 托盘中的位置信息 */
  warehousePosition: WarehousePossitionSchema | null
  /** 关联的mark */
  cargoMarkAssociations: PalletMarkSchema[]
  /** 箱货数 */
  quantity: number
}

export interface HouseBillScheduledSchema extends HouseBillSchema {
  /** 托盘信息 */ warehousePallets: PalletPositionSchema[]
  masterBill: MasterBill
}

export class OutboundV2Service extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/outbound')
  }

  // nacss通过
  async nacssPassed(houseBillId: number) {
    return this.put<ApiResponse<HouseBillSchema>>(
      `/${houseBillId}/nacss-passed`
    )
  }

  // nacss通过后驳回
  async nacssReject(houseBillId: number) {
    return this.put<ApiResponse<HouseBillSchema>>(
      `/${houseBillId}/nacss-reject`
    )
  }

  // 出库任务确认
  async deliveryConfirmation(houseBillId: number, houseBill: DeliverySchedule) {
    return this.put<ApiResponse>(`/${houseBillId}/delivery-confirmation`, {
      scheduledOutboundDate: houseBill.scheduledOutboundDate,
      deliveryOpt: houseBill.deliveryOpt,
      deliveryNote: houseBill.deliveryNote
    })
  }

  // 出库确认驳回
  async deliveryReject(houseBillId: number) {
    return this.put<ApiResponse>(`/${houseBillId}/delivery-reject`)
  }

  // 获取可以出库的提单列表
  async fetchDeliverys() {
    return this.get<ApiResponse<HouseBillSchema[]>>(`/house-bills`)
  }

  // 获取预约出库提单列表（库位信息 托盘信息 Mark信息）
  async fetchScheduled() {
    return this.get<ApiResponse<HouseBillScheduledSchema[]>>(`/scheduled`)
  }

  // 根据出库单号获取出库提单详情（库位信息 托盘信息 Mark信息）
  async outboundHouseBill(houseBillNumber: string) {
    return this.get<ApiResponse<HouseBillScheduledSchema>>(
      `/house-bill/${houseBillNumber}`
    )
  }

  // 扫描托盘并更新状态
  async scanPallet(palletCode: string, business: Business) {
    return this.put<ApiResponse>(`/pallet/${palletCode}/scan`, { business })
  }
}
